/**
 * Portuguese (pt-BR) copy for the `@omnitok/ui` login page.
 *
 * The kit ships its login strings in ES and EN only (its `language` prop
 * is `'es' | 'en'`). Portal and builder both render that page, so the PT
 * copy lives here once and goes in through the kit's own `I18nProvider`
 * (`messages={{ pt: OMNITOK_LOGIN_PT }}`), which merges it over the
 * built-ins. Every key the login page reads is listed, so nothing falls
 * through to another language.
 */
export const OMNITOK_LOGIN_PT: Record<string, string> = {
  "login.title": "Entrar",
  "login.subtitle": "Informe suas credenciais para continuar",
  "login.emailLabel": "E-mail",
  "login.emailPlaceholder": "voce@email.com",
  "login.passwordLabel": "Senha",
  "login.passwordPlaceholder": "••••••••",
  "login.rememberMe": "Lembrar de mim",
  "login.forgotPassword": "Esqueceu sua senha?",
  "login.submit": "Entrar",
  "login.split.heroTitle": "Bem-vindo de volta",
  "login.split.heroDescription":
    "Acesse seu painel de administração e gerencie sua plataforma com eficiência.",
  "login.split.copyright": "© {year} Omnitok. Todos os direitos reservados.",
};
